import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=002fd022&"
import script from "./tour.vue?vue&type=script&lang=js&"
export * from "./tour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports